import {
	QSR_CATEGORIES_FETCH_REQUEST,
	QSR_CATEGORIES_FETCH_FAILURE,
	QSR_CATEGORIES_FETCH_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case QSR_CATEGORIES_FETCH_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case QSR_CATEGORIES_FETCH_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case QSR_CATEGORIES_FETCH_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/QSRCategories.js